module.exports = __webpack_public_path__ + "img/img34_1.5e533a10.svg";